import axios from 'axios';
// bundle. The frontend only needs to stamp the Authorization header from the
// token in localStorage / the `johnwick` cookie.

export function getCookieByName(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function getAuthHeaders() {
  const token = localStorage.getItem('token') || getCookieByName('johnwick');
  return token ? {Authorization: `Bearer ${token}`} : {};
}

export const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  config => {
    const headers = getAuthHeaders();
    if (!(config.data instanceof FormData) && !headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
    Object.assign(config.headers, headers);
    return config;
  },
  error => Promise.reject(error)
);

// Refresh handshake — the request interceptor above stamps the Authorization
// header from localStorage.token. On 401 we ask Chatwoot to mint a fresh JWT;
// the new token arrives via the postMessage handler in App.js, which writes it
// to localStorage.token.
//
// A single in-flight refresh is shared across all concurrent 401s, so a burst
// of expired requests triggers exactly ONE refresh-token message (no thundering
// herd / duplicate token mints). Each failed request is then retried once with
// the fresh token.
const REFRESH_TIMEOUT_MS = 10000;
let refreshPromise = null;

function waitForFreshToken() {
  if (refreshPromise) return refreshPromise; // already refreshing → reuse it
  const previous = localStorage.getItem('token');
  // The mobile app WebView only handles the `fetch-info` event (not
  // `refresh-token`), and window.parent is the page itself there, so route
  // through the RN bridge with `fetch-info` to get a fresh appContext/token.
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage('chatwoot-dashboard-app:fetch-info');
  } else {
    window.parent.postMessage('chatwoot-dashboard-app:refresh-token', '*');
  }
  refreshPromise = new Promise((resolve, reject) => {
    const startedAt = Date.now();
    const timer = setInterval(() => {
      const current = localStorage.getItem('token');
      if (current && current !== previous) {
        clearInterval(timer);
        resolve(current);
      } else if (Date.now() - startedAt > REFRESH_TIMEOUT_MS) {
        clearInterval(timer);
        reject(new Error('Token refresh timed out'));
      }
    }, 200);
  }).finally(() => {
    refreshPromise = null;
  });
  return refreshPromise;
}

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const original = error.config;
    console.log("called this")
    if (error?.response?.status === 401 && original && !original._bspdRetried) {
      original._bspdRetried = true; // retry once only → no infinite 401 loop
      console.log("called this")
      try {
        await waitForFreshToken();
        return axiosInstance(original); // request interceptor re-stamps the new token
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);
